export type SupportedSoundCard = {
  id: string
  displayName: string
  expectedChannels: number
  matches: string[]
}

export const SUPPORTED_SOUND_CARDS: SupportedSoundCard[] = [
  {
    id: 'umc1820',
    displayName: 'UMC1820',
    expectedChannels: 10,
    matches: ['umc1820']
  }
]

export const findSupportedSoundCard = (reportedCardNames: string[] = []): SupportedSoundCard | null => {
  const normalizedNames = reportedCardNames.map((name) => name.toLowerCase())
  return (
    SUPPORTED_SOUND_CARDS.find((card) =>
      card.matches.some((matchToken) =>
        normalizedNames.some((name) => name.includes(matchToken.toLowerCase()))
      )
    ) ?? null
  )
}
